import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import * as affix from "@elements/affix";
affix.init();



import * as scrollSlide from './scripts/scroll-slide';
scrollSlide.init();


import * as smoothScroll from '@elements/smooth-scroll';

let selectors = {
    base: '.js-smoothscroll',
    link: '.js-smoothscroll__link',
    dataOffset: 'smoothscroll-offset'
}

let options = {
    scrollOffset: 0,
}
smoothScroll.init();



import * as fontColorAnimation from './scripts/font-color-animation';
fontColorAnimation.init();


import * as parallax from "./scripts/parallax";
parallax.init();


import * as formValidation from '@elements/form-validation';
formValidation.init({
    trigger: { event: 'false'}
});


import * as playVideo from './scripts/play-video';
playVideo.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();

import tab from 'bootstrap/js/dist/tab';

import 'bootstrap/js/dist/tab';

import * as floatingLabel from '@elements/floating-labels';
floatingLabel.init();


